export default {
    methods: {
        /**
         * Gets a thumbnail from an object
         * @param {object} obj
         * @param {string} placeholder
         */
        thumbnail(obj, placeholder) {
            let thumbnail = placeholder ? placeholder : '/images/no-image.png';

            if (obj.primary_asset) {
                const transform = obj.primary_asset.transforms[0];
                if (transform) {
                    return transform.url;
                }
            }

            if (!obj || !obj.assets || !obj.assets.length) {
                return thumbnail;
            }

            let primary = _.first(obj.assets, asset => {
                return asset.primary;
            });

            if (primary && primary.transforms.length) {
                thumbnail = _.first(primary.transforms).url;
            }

            return thumbnail;
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Mixins/Utils.js